var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import Cookies from "js-cookie";
function userManagerFactory({ UserManager }, settings) {
  const root = `${location.protocol}//${location.host}`;
  function getCookieData() {
    return Cookies.getJSON("je-oidc") || {};
  }
  function setCookieData(obj) {
    Cookies.set("je-oidc", obj);
  }
  const userStore = {
    set: function(key, value) {
      const data = getCookieData();
      data[key] = value;
      setCookieData(data);
      return Promise.resolve();
    },
    get: function(key) {
      const data = getCookieData();
      const value = data[key];
      return Promise.resolve(value);
    },
    remove: function(key) {
      const data = getCookieData();
      delete data[key];
      setCookieData(data);
      return Promise.resolve();
    },
    getAllKeys: function() {
      const data = getCookieData();
      const allKeys = [];
      for (const key in data) {
        allKeys.push(key);
      }
      return Promise.resolve(allKeys);
    }
  };
  const defaultSettings = {
    authority: root,
    client_id: "je_web_native",
    response_type: "code",
    scope: "openid mobile_scope offline_access",
    silent_redirect_uri: `${root}/tokenweb/content/silent-callback.html`,
    loadUserInfo: false,
    userStore
  };
  const mergedSettings = __spreadValues(__spreadValues({}, defaultSettings), settings);
  const oidcMgr = new UserManager(mergedSettings);
  return oidcMgr;
}
let tokenPromise = null;
let state = "unknown";
function reset() {
  tokenPromise = null;
  state = "unknown";
}
function silentSignIn(OidcClient, settings, force = false) {
  const oidcManager = userManagerFactory(OidcClient, settings);
  function doSignIn() {
    if (state === "unknown") {
      state = "sign-in-started";
    }
    return tokenPromise = oidcManager.signinSilent({ state: "somestate" }).then((user) => {
      state = "logged-in";
      return user.access_token;
    }).catch((error) => {
      if (error && error.message === "login_required") {
        state = "anonymous";
        return null;
      }
      state = "unknown";
      tokenPromise = null;
      throw error;
    });
  }
  if (force) {
    reset();
    return doSignIn();
  }
  return oidcManager.getUser().then((user) => {
    if (user) {
      return user.access_token;
    }
    if (tokenPromise && state !== "unknown") {
      return tokenPromise;
    }
    return doSignIn();
  }).catch(() => doSignIn());
}
export { silentSignIn, userManagerFactory };
//# sourceMappingURL=f-consumer-oidc.es.js.map
